import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Symbol } from "@/components/common";

const Splash = () => (
  <div className="min-h-screen grid place-items-center mr-grid-bg" data-testid="auth-loading">
    <Symbol className="h-10 w-10 animate-pulse" testId="auth-loading-symbol" />
  </div>
);

export function RequireAuth({ children }) {
  const { me } = useAuth();
  const loc = useLocation();
  if (me === null) return <Splash />;
  if (!me) return <Navigate to="/app/connexion" state={{ from: loc.pathname }} replace />;
  return children;
}

export function RequireMember({ children }) {
  const { me } = useAuth();
  if (me === null) return <Splash />;
  if (!me) return <Navigate to="/app/connexion" replace />;
  if (!["actif", "suspendu"].includes(me.user.status)) return <Navigate to="/candidature" replace />;
  return children;
}

export function RequireConsole({ children }) {
  const { me } = useAuth();
  if (me === null) return <Splash />;
  if (!me) return <Navigate to="/console/connexion" replace />;
  if (!me.permissions.includes("console:access")) return <Navigate to="/app" replace />;
  return children;
}
